module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"tabs":{"trap_list":"トラップ一覧","trap_ranking":"トラップランキング","insect_ranking":"虫ランキング"},"export_error":"エクスポートに失敗しました"},"en":{"tabs":{"trap_list":"Trap List","trap_ranking":"Trap Ranking","insect_ranking":"Insect Ranking"},"export_error":"Export failed"}}')
  delete Component.options._Ctor
}
